import { render, staticRenderFns } from "./OrderTransit.vue?vue&type=template&id=0ae5fcf0&scoped=true"
import script from "./OrderTransit.vue?vue&type=script&lang=js"
export * from "./OrderTransit.vue?vue&type=script&lang=js"
import style0 from "./OrderTransit.vue?vue&type=style&index=0&id=0ae5fcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5fcf0",
  null
  
)

export default component.exports